export default "__VITE_ASSET__CF$Dk4Qk__";